import React from 'react';
import { useSite } from '../context/SiteContext';

const CommitmentSection = ({ variant = 'default' }) => {
  const { siteData } = useSite();
  const commitment = siteData?.commitment;

  if (!commitment?.content) return null;

  // Split content into paragraphs and render
  const paragraphs = commitment.content.split('\n\n');

  if (variant === 'box') {
    return (
      <div className="mt-12 mb-16 md:mb-20 mx-auto max-w-4xl px-4">
        <div 
          className="bg-[#f8f6f3] border border-[#d4cfc7] rounded-lg p-8 md:p-10"
          data-testid="commitment-section-box"
        >
          <h3 className="text-2xl font-serif text-[#2d4a47] mb-6 text-center">
            {commitment.title || 'Our Commitment'}
          </h3>
          <div className="space-y-4 text-gray-700 leading-relaxed">
            {paragraphs.map((paragraph, index) => (
              <p key={index} className="text-center">
                {paragraph}
              </p>
            ))}
          </div>
        </div>
      </div>
    );
  }

  // Default full-width section for homepage
  return (
    <section 
      className="pt-16 md:pt-24 pb-20 md:pb-28 bg-[#f5f1eb]"
      data-testid="commitment-section"
    >
      <div className="max-w-4xl mx-auto px-4 text-center">
        <h2 className="text-3xl md:text-4xl font-serif text-[#2d4a47] mb-8">
          {commitment.title || 'Our Commitment'}
        </h2>
        <div className="space-y-6 text-gray-700 leading-relaxed text-lg">
          {paragraphs.map((paragraph, index) => (
            <p key={index}>
              {paragraph}
            </p>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CommitmentSection;
